import { initialState } from "us.collection.admin/reducers/CreditorApproval/State";
import { CreditorApproval } from "us.collection.admin/constants/Actions";

const {
  GET_CREDITORS_LIST_FOR_APPROVAL,
  GET_CREDITORS_LIST_FOR_APPROVAL_SUCCESS,
  GET_CREDITORS_LIST_FOR_APPROVAL_FAIL,

  APPROVE_CREDITOR,
  APPROVE_CREDITOR_SUCCESS,
  APPROVE_CREDITOR_FAIL,
} = CreditorApproval;

export default (state = initialState, { payload, type }: any) => {
  switch (type) {
    case GET_CREDITORS_LIST_FOR_APPROVAL:
      return Object.assign({}, state, {
        pendingApprovalsListLoading: true,
      });
    case GET_CREDITORS_LIST_FOR_APPROVAL_SUCCESS:
      return Object.assign({}, state, {
        pendingApprovalsListLoading: false,
        pendingApprovalsList: payload?.data,
      });
    case GET_CREDITORS_LIST_FOR_APPROVAL_FAIL:
      return Object.assign({}, state, {
        pendingApprovalsList: state.pendingApprovalsList,
        pendingApprovalsListLoading: false,
      });
 case APPROVE_CREDITOR:
      return Object.assign({}, state, {
        pendingApprovalsListLoading: true,
      });
    case APPROVE_CREDITOR_SUCCESS:
      return Object.assign({}, state, {
        pendingApprovalsListLoading: false,
      });
    case APPROVE_CREDITOR_FAIL:
      return Object.assign({}, state, {
        pendingApprovalsList: state.pendingApprovalsList,
        pendingApprovalsListLoading: false,
      });
    default:
      return state;
  }
};
